angular.module('aprima-core-ui').directive('apMetadata', ['$compile', 'MetadataService', function ($compile, MetadataService) {
    'use strict';

    var ngMinMaxLengthUnsupportedType = {
        time: true,
        date: true,
        'datetime-local': true,
        week: true,
        month: true,
        radio: true,
        checkbox: true
    };

    var ngMinMaxLengthUnsupportedElement = {
        select: true,
        'ap-patient-search': true,
        'ap-find-pharmacy': true
    };

    var ngMinMaxUnsupportedType = {
        checkbox: true,
        email: true,
        radio: true,
        text: true,
        url: true
    };

    var ngMinMaxUnsupportedElement = {
        select: true,
        'ap-patient-search': true,
        'ap-find-pharmacy': true
    };

    //Dynamically applies minimum/maximum validation logic based on values in $scope.metadata.
    return {
        priority: 1001,
        terminal: true,
        replace: false,
        restrict: 'A',
        compile: compile
    };

    function compile(element, attrs) {
        //apMetadata does not need value. If it does not have a value, metadata directives should use the value in ngModel directive
        var metadata = attrs.apMetadata || '';

        //apRequired uses the ngModel to determine which property to map to a property on scope.metadata
        //so don't pass in ngModel here, otherwise ap-required will be using extra watchers
        applyApRequired(element, metadata);

        if(!metadata && attrs.ngModel) {
            metadata = MetadataService.convertNgModelExprToMetadataExpr(attrs.ngModel);
        }

        if(isMinMaxCompatible(element, attrs)) {
            applyNgMinMax(element, metadata);
        }

        if(isMinMaxLengthCompatible(element, attrs)) {
            applyNgMinMaxLength(element, metadata);
        }

        element.removeAttr('ap-metadata');

        return {
            post: function postLink(scope, element) {
                $compile(element)(scope);
            }
        };
    }

    function applyApRequired(element, metadata) {
        element.attr('ap-required', metadata ? metadata + '.IsRequired' : '');
    }

    function applyNgMinMax(element, metadata) {
        //only set these attributes if they weren't set manually
        if(!element.attr('ng-min')) {
            element.attr('ng-min', metadata ? metadata + '.Minimum' : '');
        }

        if(!element.attr('ng-max')) {
            element.attr('ng-max', metadata ? metadata + '.Maximum' : '');
        }
    }

    function applyNgMinMaxLength(element, metadata) {
        //only set these attributes if they weren't set manually
        if(!element.attr('ng-minlength')) {
            element.attr('ng-minlength', metadata ? metadata + '.MinLength' : '');
        }

        if(!element.attr('ng-maxlength')) {
            element.attr('ng-maxlength', metadata ? metadata + '.MaxLength' : '');
        }
    }

    // ng-min, ng-max can work if element is not <select> or one of our custom directives where it doesn't make sense
    // and if the input actually supports these attributes (according to angular)
    function isMinMaxCompatible(element, attrs) {
        return !ngMinMaxUnsupportedElement[element[0].nodeName.toLowerCase()] && !ngMinMaxUnsupportedType[attrs.type];
    }

    // ng-minlength, ng-maxlength can work if element is not <select> or one of our custom directives where it doesn't make sense
    // and if the input actually supports these attributes (according to angular)
    function isMinMaxLengthCompatible(element, attrs) {
        return !ngMinMaxLengthUnsupportedElement[element[0].nodeName.toLowerCase()] && !ngMinMaxLengthUnsupportedType[attrs.type];
    }
}]);